import React from "react";
import { UrlObject } from "url";
import { SVGProps } from "react-html-props";
import SideNavItem from "./SideNavItem";
import SideNavItemIcon from "./SideNavItemIcon";

/**
 * A main side nav section. When selected, its icon sits on the raised white
 * tile and takes `activeColorClassName`; sections sharing a `group` share one
 * tile, which slides between them.
 */
export default function SideNavSectionItem(p: {
  svg: React.FC<SVGProps>;
  label: string;
  href: string | UrlObject;
  activeRegex: RegExp;
  group: string;
  activeColorClassName?: string;
}) {
  return (
    <SideNavItem
      icon={(isActive) => (
        <SideNavItemIcon
          svg={p.svg}
          isActive={isActive}
          group={p.group}
          activeColorClassName={p.activeColorClassName ?? "text-neutral-950"}
        />
      )}
      label={p.label}
      href={p.href}
      activeRegex={p.activeRegex}
    />
  );
}
